<template>
	<div
  id="vtoutages-user-menu-container"
  class="user-menu-container"
  v-bind:class="{
    mobile: isMobile() || isTablet(),
    desktop: !isMobile() && !isTablet()
    }">
      <div class="header-container">
        <span
        class="close-button"
        v-on:click="hideUserMenu()">×</span>
        <p class="username">{{user.username}}</p>
      </div>
      <ul class="menu-items">
        <li class="menu-item"
        v-on:click="showUserProfileModal()"
        title="View / edit your profile">
          <span class="icon">
            <img class="avatar" src="../../../assets/img/user-menu-icon-profile.png" alt="profile-icon">
          </span>
          <span class="text">Profile</span>
        </li>
        <li
        class="menu-item"
        v-on:click="showUilityOutagesModal()">
        <span class="icon">
          <img class="avatar" src="../../../assets/img/user-menu-icon-utilities.png" alt="utilities-icon">
        </span>
        <span class="text">Outage Data Upload</span>
        </li>
        <li
        class="menu-item"
        v-if="userIsAdmin && !isMobile() && !isTablet()"
        v-on:click="showAdminModal"
        title="Go to Administrator view">
        <span class="icon">
          <img class="avatar" src="../../../assets/img/user-menu-icon-admin.svg" alt="utilities-icon">
        </span>
        <span class="text">Admin</span>
        </li>
      </ul>
      <div class="buttons-container">
            <b-button
            v-on:click="logOut()">Sign Out</b-button>
      </div>
	</div>
</template>

<script>
import vueMqMixin from "../mixins/VueMqMixin";

export default {
  name: "UserMenu",
  mixins: [vueMqMixin],
  props: {
      user: Object,
      userIsAdmin: Boolean,
      logOut: Function,
      showAdminModal: Function,
      hideUserMenu: Function,
      showUserProfileModal: Function,
      showUilityOutagesModal: Function,
      hideUilityOutagesModal: Function
  },
  created() {
    setTimeout(this.positionAndDisplayUserMenu, 10);
  },
  methods: {
      positionAndDisplayUserMenu() {
        let footerContainerSelector = undefined;

        if (this.isMobile() || this.isTablet()) {
          footerContainerSelector = '.mobile-footer';
        } else {
          footerContainerSelector = '.footer-container';
        }

        const $footerContainer = document.querySelector(footerContainerSelector);
        const $menuContainer = document.getElementById('vtoutages-user-menu-container');
        const menuContainerStyle = $menuContainer.style;
        menuContainerStyle.bottom = window.getComputedStyle($footerContainer).height;
        menuContainerStyle.display = 'block';
      }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/partials/_variables.scss";

.user-menu-container{
  display: none;
  position: absolute;
  width: 250px;
  height: 200px;
  padding: 20px;
  background-color: #fff;
  z-index: 999999;
  font-size: 13px;
  color: $navy;

  &.desktop{
    right: 73px;
  }

  &.mobile{
    left: 25%;
  }

  .header-container{
    position: relative;
    border-bottom: 1px solid $greyText;

    .close-button{
      position: absolute;
      top: -15px;
      right: -10px;

      &:hover{
        cursor: pointer;
      }
    }
  }

  .username{
    margin: 0;
    padding-bottom: 10px;
    font-weight: $xbold;
  }

  .menu-items{
    margin-top: 10px;

    .menu-item{
      &:hover{
        cursor: pointer;
      }

      margin-bottom: 10px;

      .icon{
        display: inline-block;
        width: 12px;
        margin: 0 10px 0 0;

        img{
          position: relative;
          display: inline-block;
          width: 100%;
          top: -2px;
        }
      }
    }
  }

  .buttons-container{
    position: absolute;
    bottom: 20px;
    right: 20px;

    button{
      padding: 0 10px;
      background-color: $navy;
      border-radius: 20px;
      font-size: 13px;
    }
  }
}



</style>
